import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const mineVuex = createNamespacedHelpers("mine");
const assetsVuex = createNamespacedHelpers("assets");
import formatter from "@utils/formatter";
export default {
  name: "giftsHead",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "taskCount", "setting"]),
    ...userVuex.mapState(["userData"]),
    ...assetsVuex.mapState(["assetsList"]),
    route() {
      return this.$route.path;
    },
    avatarUrl() {
      return "https://static.tapcoins.app/avatar";
    },
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      popMenuShow: false,
      starInfo: {
        balance: 0
      }
    };
  },
  methods: {
    ...assetsVuex.mapActions(["getAssetsChains", "getAssetsList"]),
    onSkip(path, id) {
      if (path == "squad") {
        this.$router.push(`/${path}?id=${id}`);
        return;
      }
      this.$router.push(`/${path}`);
    },
    formatList() {
      console.log("this.assetsList", this.assetsList);
      const list = this.assetsList.filter(item => {
        return item.chain == 'telegram' && item.name == 'Stars';
      });
      if (list && list.length > 0) {
        this.starInfo = list[0];
      }
      console.log("this.list", this.starInfo);
    },
    async refreshFnc() {
      console.log("ab ccccc");
      await this.getAssetsList();
      this.formatList();
    }
  },
  async mounted() {
    this.refreshFnc();
  }
};